export default __webpack_public_path__ + "static/media/le_croise7.fe3ff04b.jpg";